import { cn } from "@/lib/utils"

interface GuruMeditationIconProps {
  className?: string
}

export function GuruMeditationIcon({ className }: GuruMeditationIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn("size-6", className)}
    >
      {/* Head */}
      <circle cx="12" cy="6.5" r="3" />

      {/* Halo */}
      <circle cx="12" cy="6.5" r="4.5" />

      {/* Body outline */}
      <path d="M7.5 12a7.5 7.5 0 0 1 9 0" />

      {/* Arms resting inward (mudra) */}
      <path d="M9 12c-.8 2-2.4 3.2-4 3.2h2" />
      <path d="M15 12c.8 2 2.4 3.2 4 3.2h-2" />

      {/* Hands + center curve */}
      <path d="M9 15.2c1.1 1.2 2 1.8 3 1.8s1.9-.6 3-1.8" />

      {/* Legs / lotus pose */}
      <path d="M7 18c1.8 1.8 3.5 2.5 5 2.5s3.2-.7 5-2.5" />
      <path d="M4.5 21h15" />
    </svg>
  )
}
